/* eslint-disable no-unused-vars */
import { Palette } from 'config';
import styled from 'styled-components';
import { paymentsAPI } from 'services/payments.service';
import { Loader } from 'components';

function formatCurrency(num) {
  if (!num) return 0;
  const minus = num < 0 ? '- ' : '';
  const formattedNumber = new Intl.NumberFormat('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 3,
  }).format(Math.abs(num));

  return minus + '$' + formattedNumber;
}

const getTitle = {
  currentBalance: 'Current Balance',
  billingTreshold: 'Billing Threshold',
};

export const Balance = ({ fieldName }) => {
  const { data, isError, isLoading, isFetching } = paymentsAPI.useGetBalanceDetailsQuery(
    undefined,
    {
      selectFromResult: (response) => {
        if (response.data) {
          return {
            ...response,
            data: { ...response.data, currentValue: response.data[fieldName] },
          };
        }
        return response;
      },
    },
  );

  if (isError) {
    return <div>Error</div>;
  }

  if (isFetching) {
    return (
      <Container>
        <Loader.Local delay={0} />
      </Container>
    );
  }

  return (
    <Container>
      <SubHeading>{getTitle[fieldName]}</SubHeading>
      <Metric isRed={data?.currentValue < 0}>{formatCurrency(data?.currentValue)}</Metric>
    </Container>
  );
};

const Container = styled.div`
  background: #fff;
  border-radius: 8px;
  box-shadow: 0px 1px 3px rgba(30, 50, 70, 0.1), 0px 1px 2px rgba(30, 50, 70, 0.06);
  padding: 24px;
`;

const SubHeading = styled.h3`
  display: flex;
  gap: 8px;
  align-items: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${Palette.PrimaryGray._700};
`;

const Metric = styled.div`
  font-weight: 700;
  font-size: 32px;
  line-height: 40px;
  margin-top: 16px;
  color: ${({ isRed }) => (isRed ? `${Palette.Red._600}` : `${Palette.PrimaryGray._700}`)};
`;
